import { ModalDialog } from '@/scripts/theme/modal-dialog'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { DeferredMedia } from '@/scripts/theme/deferred-media'

export class ProductModal extends ModalDialog {
	static override htmlSelector = 'product-modal'
	static selectors = {
		container: '[data-uc-product-modal-container]',
		thumbnailContainer: '.product-media-modal__thumbnail'
	}
	thumbnailContainer: HTMLElement
	thumbnails: NodeListOf<HTMLElement>
	medias: NodeListOf<HTMLElement>
	constructor() {
		super()
		this.thumbnailContainer = q.rs(ProductModal.selectors.thumbnailContainer, this)
		this.thumbnails = q.rl('[data-media-id]', this.thumbnailContainer)

		this.thumbnails.forEach(thumbnail => {
			thumbnail.addEventListener('click', this.onClickThumbnail.bind(this))
		})

		this.medias = q.rl('[data-uc-product-modal-container] .global-media-settings', this)
		this.medias.forEach(media => {
			const mediaId = q.ra(media, 'data-media-id')
			const observer = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						this.thumbnails.forEach(thumbnail => {
							const _mediaId = q.ra(thumbnail, 'data-media-id')
							thumbnail.classList.toggle('active', mediaId == _mediaId)
						})
					}
				});
			}, { threshold: 0.1 });
			observer.observe(media);
		})
	}	

	override hide() {
		super.hide()
	}

	override show(opener: HTMLElement) {
		super.show(opener)
		const openedById = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null
		this.showActiveMedia(openedById || 'NO_OPENER')
	}

	onClickThumbnail(event: Event) {
		const target = q.rClosestTarget(event, '[data-media-id]')
		const openedById = q.ra(target, 'data-media-id')
		this.showActiveMedia(openedById || 'NO_OPENER')
	}

	showActiveMedia(openedById: string) {
		
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${openedById}"])`).forEach(
			(element) => {
				element.classList.remove('active')
			}
		)
		const container = q.rs(ProductModal.selectors.container, this)
		const activeMedia = q.os<
			HTMLImageElement | HTMLVideoElement | HTMLIFrameElement | DeferredMedia
		>(`[data-media-id="${openedById}"]`, container)
		if (!activeMedia) {
			console.error('no active media found')
			return
		}
		this.thumbnails.forEach(thumbnail => {
			const mediaId = q.ra(thumbnail, 'data-media-id')
			thumbnail.classList.toggle('active', mediaId == openedById)
		})
		const activeMediaTemplate = activeMedia.querySelector('template')
		const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null
		activeMedia.classList.add('active')
		activeMedia.scrollIntoView()
		void window.Ucoast.mediaManager.playAllInContainer(this)

		
		const activeMediaWidth = activeMedia.width
			? parseInt(`${activeMedia.width}`)
			: activeMedia.clientWidth
		container.scrollLeft = (activeMediaWidth - container.clientWidth) / 2

		if (
			activeMedia instanceof DeferredMedia &&
			activeMediaContent &&
			activeMediaContent.querySelector('.js-youtube')
		)
			activeMedia.loadContent()
	}
}
